const AppConstant = {
  RECAPTCHA_SITE_KEY: '6LcCEZUgAAAAAHfQIJzV0kp1OZiti6ANfePnUbOb',

  TOKEN_COOKIE_NAME: 'HYUNSUB_TOKEN',
  TOKEN_PUBLIC_KEY:
    '-----BEGIN PUBLIC KEY-----\nMIGbMBAGByqGSM49AgEGBSuBBAAjA4GGAAQAo4L53u7fUVlrp0u/PV/2uZLFxqj8r5CYp02N5jDzx7bcgi519x4lVWCmS1MWD5n+2tLPynXkEauWUNc5Kt1A7ccAv85CqJCrkg50VONgp7ElgJ5kY1TI9qahDK38m3xvAGhgzA9rinRdo9rjiKMXXDzf8MaC9kT/SzOb1uxAuhf8ORU=\n-----END PUBLIC KEY-----',
  TOKEN_PAYLOAD_FIELD: 'payload',

  APPS_HOME: 'https://apps.hyunsub.kim',
  PROFILE_HOME: 'https://auth.hyunsub.kim/profile',
  /** 로그인 화면. 뒤에 `?url=<돌아올 주소>`를 붙인다 */
  AUTH_LOGIN: 'https://auth.hyunsub.kim/login',

  video: {
    SETTING_SUBTITLE_DEFAULT_FONT_SIZE: '18',
    SETTING_SUBTITLE_FONT_SIZE: 'SETTING_SUBTITLE_FONT_SIZE',
  },

  comic: {
    /** 만화마다 읽는 방식(ltr/rtl/scroll). 키 뒤에 comicId */
    READING_MODE: 'COMIC_READING_MODE_',
  },

  file: {
    HOST: 'https://file.hyunsub.kim',
  },
};

export default AppConstant;
